import { AreaFactorBase } from './base/area-factor-base';

export class AreaFactor extends AreaFactorBase { }